import { useMemo } from 'react';
import moment from 'moment';
import { useListEntitiesQuery } from '../../api/useListEntitiesQuery';
import { useRouteParams } from '../../hooks/useRouteParams';
import { AsyncComponentHookResult } from '../../../Types/ComponentHookResult';
import { useBaseEntityList, UseEntityListActions } from '../../hooks/useBaseEntityList';
import { EntitiesDTO, EntityDTO } from '../../DocumentVault.meta';

export const useEntityList = (): AsyncComponentHookResult<EntitiesDTO, UseEntityListActions> & {
  isDownloadingFile: boolean;
  currentVideoEntity: EntityDTO | null;
} => {
  const { clientId, path, providerType, filterableByYear } = useRouteParams();
  const queryResult = useListEntitiesQuery({ clientId, path, providerType, filterableByYear });

  const base = useBaseEntityList();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const { items, ...rest } = queryResult.data;

    return {
      ...rest,
      items: items.map(entity => ({
        ...entity,
        lastModified: entity.lastModified
          ? moment(entity.lastModified).format('MMM. D, YYYY')
          : null,
      })),
    };
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
    ...base,
  };
};
